// extracted by mini-css-extract-plugin
module.exports = {"spectrum-Button":"PrimaryActionButton_spectrum-Button__3HZUY","ant-btn":"PrimaryActionButton_ant-btn__xtX3d","button":"PrimaryActionButton_button__3C6RP"};